export const environment = {
  production: true,
  CRYPTO_KEY: "4SLDKTE235AS65SH",
  CRYPTO_VI: "6DFG6SHFS6SDF2SD",
  DOMAIN:"https://perseo-seguros-i2cs-lacaixa.icp.es/api/I2CS",
  API: {
    AREA_CLIENTES: {
      RecuperarLogin: "AreaClientes/loginRecuperar",
      PermitirCambiarLogin: "AreaClientes/permitirLoginCambiar",
      CambiarLogin: "AreaClientes/loginCambiar",
      ObtenerUsuario: "AreaClientes/obtenerUsuario"
    },
    LOGIN: {
      Authenticate: 'AreaClientes/loginParticulares',
      Logout: 'Logout'
    },
    WEB: {
      GUARDAR_DATOS_WEB: 'Web/GuardarDatosWeb', //Recogida de datos de la web de ciberseguridad
      OBTENER_DATOS_WEB: 'Web/ObtenerDatosWebCiberseguridad', //Obtención de datos de la web de ciberseguridad
      MODIFICAR_DATOS_WEB: 'Web/ModificarDatosWebCiberseguridad', //Modificación de datos de la web de ciberseguridad.
      SUSPENDER_POLIZA: 'Web/SuspenderPolizaCiberseguridad', //Suspensión de la póliza de ciberseguridad.
      COMPROBAR_IBAN: 'Web/CheckIBAN', //Comprueba si el iban es válido.
      TOKEN: "Web/Token", //Devuelve token autorización.
      VALIDAD_DNI: 'Web/ValidarDni', //Verificación de existencia del registro del DNI.
      OBTENER_TARIFAS: 'Web/ObtenerTarifasCiberseguridad', //Obtención de datos de las tarifas de ciberseguridad de la Caixa.
      VALIDAR_IBAN_POLIZA: 'Web/ValidarIbanPoliza', //Comprueba si los últimos digitos del iban coinciden con el de la póliza.
      OBTENER_DOCUMENTO_POLIZA: 'Web/ObtenerDocumentoPoliza', //Obtiene el documento de la póliza contratada
      OBTENER_POLIZAS: 'Web/ObtenerPolizasCiberseguridad' //Obtiene todas las pólizas asignadas a un num documento, es decir, de un mismo usuario.
    },
    SINIESTRO: {
      OBTENER_SINIESTROS: 'Siniestros/ObtenerListadoSiniestros', //Obtención del listado de siniestro asociados a una póliza
      VALIDAR_APERTURA_SINIESTRO: 'Siniestros/ValidarAperturaSiniestro',
      OBTENER_DATOS_TITULAR: 'Siniestros/DatosTitularPoliza',
      OBTENER_TIPOS_SINIESTROS: 'Siniestros/TiposSiniestro',
      OBTENER_COBERTURAS: 'Siniestros/Coberturas',
      CREAR_SINIESTRO: 'Siniestros/AperturaSiniestro',
      ADJUNTAR_DOCUMENTOS_SINIESTRO: 'Siniestros/AdjuntarDocumentos',
      OBTENER_DOCUMENTOS_SINIESTRO: 'Siniestros/ObtenerDocumentosSiniestro'
    }
  },



  CREDENTIALS_FAC: {
    "u": "ext.caixa",
    "p": "$7OloiO6NwHL46oUgE6he*QjR.J3a5"
  },

  IH_INICIAL: "H4sIAAAAAAACCqpWykxRsjIyNNFRyklXslJKLdZ1DVbSUcpPA3K0DQytDAyAvIxiIM85MbMi0THAE8gvL6kCCgTl5ybmJacqBJck5qUkFqUohGTmpirVAgAAAP//"
};
